import { Directive, ElementRef, Output, OnInit, OnDestroy, EventEmitter } from '@angular/core';

@Directive({ selector: '[parentClick]' })
export class OnParentClickDirective implements OnDestroy, OnInit  {
    @Output() parentClick:EventEmitter<void> = new EventEmitter<void>();

    constructor(private el: ElementRef) {}

    ngOnInit() {
        if (this.el.nativeElement.parentNode) {
            this.el.nativeElement.parentNode.addEventListener('click', () => this.onClick())
        }
    }

    private onClick() {
        this.parentClick.emit();
    }

    ngOnDestroy() {
        if (this.el.nativeElement.parentNode) {
            this.el.nativeElement.parentNode.removeEventListener('click', () => this.onClick())
        }
    }
    
}


// WEBPACK FOOTER //
// ./web/static/services/directives/OnParentClick.ts